module.exports = __webpack_public_path__ + "img/bt_facebook_hover.c224db76.svg";